export interface ICommand { }

export class CreateCapexAccountCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Capex.Commands.CreateCapexAccountCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	Classification: any

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, classification: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.Classification = classification
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Capex.Commands.CreateCapexAccountCommandV1, TCh.Domain.Quest'
	}

}

export class DeleteCapexAccountCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Capex.Commands.DeleteCapexAccountCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string

	constructor (workspaceId: number, strategyId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Capex.Commands.DeleteCapexAccountCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateCapexAccountCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Capex.Commands.UpdateCapexAccountCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	Classification: any

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, classification: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.Classification = classification
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Capex.Commands.UpdateCapexAccountCommandV1, TCh.Domain.Quest'
	}

}

